import { render, staticRenderFns } from "./FormBuilderAddEdit.vue?vue&type=template&id=77f4ce61&scoped=true&"
import script from "./FormBuilderAddEdit.vue?vue&type=script&lang=js&"
export * from "./FormBuilderAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderAddEdit.vue?vue&type=style&index=0&id=77f4ce61&prod&scoped=true&lang=css&"
import style1 from "./FormBuilderAddEdit.vue?vue&type=style&index=1&id=77f4ce61&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f4ce61",
  null
  
)

export default component.exports